import translation from "./de.json";

/**
 * Explicit German FrontDesk+ translation resource for bounded browser builds.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const resources = { de: { translation: germanFrontDeskTranslation } };
 * ```
 */
export const germanFrontDeskTranslation = translation;
